export default "__VITE_ASSET__b2eb36c4__"